import React from 'react';
import Report from '../../components/Report';

const ReportScreen = () => <Report />;

export default ReportScreen;
